import React from "react";

const GaitPathwayBlocked = () => {
  return (
    <>
      <div className="person-detected-modal text-center flex-column">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="519"
          viewBox="0 0 240 519"
          fill="none"
        >
          <rect
            x="7.5"
            y="289.405"
            width="225"
            height="221.19"
            fill="#FFFF54"
            fill-opacity="0.6"
            stroke="#FFFF54"
            stroke-width="15"
          />
          <path
            d="M150.296 30C150.296 46.5687 136.729 60 120.008 60C103.287 60 89.7204 46.5687 89.7204 30C89.7204 13.4312 103.287 0 120.008 0C136.729 0 150.296 13.4312 150.296 30ZM114.96 220V300C114.96 311.062 105.937 320 94.7683 320C83.5998 320 74.5766 311.062 74.5766 300V160.562L56.5492 190.312C50.8071 199.75 38.4018 202.812 28.8423 197.125C19.2825 191.438 16.1903 179.188 21.9348 169.688L58.7071 109.125C69.6549 91.0625 89.3418 80 110.606 80H129.41C150.674 80 170.361 91.0625 181.34 109.125L218.064 169.688C223.806 179.188 220.714 191.438 211.186 197.125C201.595 202.812 189.228 199.75 183.486 190.312L165.439 160.562V300C165.439 311.062 156.416 320 145.248 320C134.079 320 125.056 311.062 125.056 300V220H114.96Z"
            fill="#802392"
          />
        </svg>

        <div
          style={{
            paddingTop: "32px",
            display: "flex",
            flexDirection: "column",
          }}
          className="fz-30 fw-700 text-center lh-normal mb-0 align-center"
        >
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            Please stay clear
          </h1>
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            of the pathway
          </h1>
          <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">
            during calibration.
          </h1>
        </div>
      </div>
    </>
  );
};

export default GaitPathwayBlocked;
